import {WebsiteUserModel} from '../widgets/form-section/website-user-input/website-user.model';

export class SocialMediaModel extends WebsiteUserModel {
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/network/social-media.model.ts